
<!-- , 'display': isMultiPanePanel() ? 'flex' : '', [style.flex-flow]="'column wrap'" -->
<!--
Moved this into a method in the class, Jul 2021. Remove this in the Nov sprint
    [ngClass]="{
      'hideTitleBar-isNot-singlePanePage': hideTitleBar && !isSinglePanePage && !onMobile,
      'hideTitleBar-is-singlePanePage': hideTitleBar && isSinglePanePage && !onMobile && !pageHasContextForm,
      'is-singlePanePage': !hideTitleBar && isSinglePanePage && !onMobile && !pageHasContextForm,
      'isNot-singlePanePage': !hideTitleBar && !isSinglePanePage && !onMobile
    }"

[ngStyle]="{'height': onMobile ? '100%' : null}"
-->
<div class="standard-panel">
  @if (activated) {
    @if (menuPanel) {
      <section lm-page-pane-menu-component
        class="menu-pane"
        [ngStyle]="{'padding-top': insideTabs ? '40px' : ''}"
        [panel]="panel"
        [messageRuleView]="messageRuleView"
        (panelContentDisplayed)="onPanelContentDisplayed($event)"
      ></section>
    }
    @if (multiPanePanel && !dashboardPanePanel && !menuPanel && !singleUrlPanePanel && !multiListPanel) {
      <div>
        <!--
        this doesn't appear to exist in lm-page-pane-list.component
        (sendContextMessageEvent)="onSendContextMessageEvent($event)"
        -->
        @for (pane of orderedUIPanes; track pane) {
          <section lm-page-pane-list-component
            id="{{pane.paneSpec.paneId}}"
            [panel]="panel"
            [pane]="pane.paneSpec"
            [listSpec]="pane.paneSpec.pane.listSpec"
            [pageHasContextForm]="pageHasContextForm"
            [pageHasTabs]="pageHasTabs"
            [isVerticalPane]="pane.isVertical"
            [ngClass]="pane.classes"
            [style.width]="pane.verticalSplitWidth"
            [lmBuildDependentPaneDetail]="LMBuildDependentPaneDetail"
            (paneContentModified)="onPaneContentModified($event)"
            (panelDataUpdated)="onPanelDataUpdated($event)"
            (updateToolbarStateEvent)="onUpdateToolbarStateEvent()"
            (paneListContentDisplayed)="onPanelContentDisplayed($event)"
            (paneListRowActivated)="onPaneListRowActivated($event)"
            (paneListRowDeactivated)="onPaneListRowDeactivated($event)"
            (paneListRowSelected)="onPaneListRowSelected($event)"
            (paneListSendContextMessageEvent)="onPaneListSendContextMessageEvent($event)"
          ></section>
        }
      </div>
    }
    @if (dashboardPanePanel) {
      <!--
      these do not appear to exist in lm-page-pane-dashboard-component
      (paneContentModified)="onPaneContentModified($event)"
      (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
      -->
      <section lm-page-pane-dashboard-component
        [pane]="panel"
        [messageRuleView]="messageRuleView"
        [ngClass]="{'page-dashboard-tab': insideTabs}"
        [columns]="panel.dashboardColumns"
        (contentModified)="onContentModified($event)"
        (panelDataUpdated)="onPanelDataUpdated($event)"
        (panelContentDisplayed)="onPanelContentDisplayed($event)"
        (sendContextMessageEvent)="onSendContextMessageEvent($event)"
      ></section>
    }
    <!--
    causing issues with our heights when a search form and search tags are used.
    Need a new way to layout a list with all the the variaos container (toolbar, searchform, searchtags,
    and finally grid.
    class="pane single"
    [style.padding]="'20px'"
    -->
    <!--
    does not appear to exist in lm-page-pane-list-component
    (sendContextMessageEvent)="onSendContextMessageEvent($event)"
    -->
    @if (singlePanePanel && !menuPanel && !singleUrlPanePanel && !dashboardPanePanel && !multiListPanel) {
      <section lm-page-pane-list-component
        id="{{panel.id}}"
        [panel]="panel"
        [pane]="singlePane"
        [listSpec]="singlePane.listSpec"
        [overrideListTitle]="overrideListTitle"
        [pageHasContextForm]="pageHasContextForm"
        [ngClass]="{'in-page-tab': insideTabs, 'single-pane': panel.panes?.length === 1}"
        (panelDataUpdated)="onPanelDataUpdated($event)"
        (paneContentModified)="onPaneContentModified($event)"
        (updateToolbarStateEvent)="onUpdateToolbarStateEvent()"
        (paneListContentDisplayed)="onPanelContentDisplayed($event)"
        (paneListRowSelected)="onPaneListRowSelected($event)"
        (paneListSendContextMessageEvent)="onPaneListSendContextMessageEvent($event)"
      ></section>
    }
    @if (singleUrlPanePanel) {
      <section lm-page-pane-url-component
        class="url-pane"
        [panel]="panel"
        automationId="{{panel.automationId}}"
        [fromDataView]="messageRuleView"
        (panelContentDisplayed)="onPanelContentDisplayed($event)"
        (panelDataUpdated)="onPanelDataUpdated($event)"
      ></section>
    }
    @if (multiListPanel) {
      <section lm-page-pane-multi-list
        [panel]="panel"
        [fromDataView]="messageRuleView"
        (contentModified)="onContentModified($event)"
        (panelContentDisplayed)="onPanelContentDisplayed($event)"
        (updateToolbarStateEvent)="onUpdateToolbarStateEvent()"
        (sendContextMessageEvent)="onSendContextMessageEvent($event)"
      ></section>
    }
  }
</div>
